export const MAX_WAYPOINTS = 3;

export const MAX_DURATION_HOURS = 8;
export const MIN_PASSENGERS = 1;
export const MAX_PASSENGERS = 6;
export const MIN_LUGGAGE = 0;
export const MAX_LUGGAGE = 6;

export const BELGRADE_CENTER = {
  lat: 44.81631398468087,
  lng: 20.460408134616113,
};

export const BELGRADE_AIRPORT_COORDS = {
  lat: 44.8192573,
  lng: 20.2909045,
};

/** Default pickup (From) — Hyatt Regency Belgrade */
export const DEFAULT_PICKUP_COORDS = {
  lat: 44.812623861627046,
  lng: 20.43454158217243,
};

export const DEFAULT_PICKUP_ADDRESS = "Hyatt Regency Belgrade";

export const BELGRADE_AIRPORT_ADDRESS = "Belgrade Nikola Tesla Airport";

const AIRPORT_COORD_EPSILON = 0.0001;

export function isAirportCoords(coords: { lat: number; lng: number } | null): boolean {
  if (!coords) return false;
  return (
    Math.abs(coords.lat - BELGRADE_AIRPORT_COORDS.lat) < AIRPORT_COORD_EPSILON &&
    Math.abs(coords.lng - BELGRADE_AIRPORT_COORDS.lng) < AIRPORT_COORD_EPSILON
  );
}

export function clampDurationHours(hours: number, minHours: number): number {
  return Math.min(MAX_DURATION_HOURS, Math.max(minHours, hours));
}

/** Matches form card width + gutter for map centering offset */
export const BOOKING_PANEL_MAX_WIDTH_PX = 440;
export const BOOKING_PANEL_GUTTER_PX = 20;
export const BOOKING_PANEL_VIEWPORT_INSET_PX = 40;
export const BOOKING_PANEL_LAYOUT_BREAKPOINT_PX = 768;

export function getBookingPanelWidthPx(viewportWidth: number): number {
  return Math.min(
    BOOKING_PANEL_MAX_WIDTH_PX,
    Math.max(0, viewportWidth - BOOKING_PANEL_VIEWPORT_INSET_PX)
  );
}

export function getBookingPanelOffsetPx(viewportWidth: number): number {
  if (viewportWidth <= BOOKING_PANEL_LAYOUT_BREAKPOINT_PX) return 0;
  return BOOKING_PANEL_GUTTER_PX + getBookingPanelWidthPx(viewportWidth);
}

export function getVisibleMapCenter(map: {
  getSize: () => { x: number; y: number };
  containerPointToLatLng: (point: [number, number]) => { lat: number; lng: number };
}): { lat: number; lng: number } {
  const size = map.getSize();
  const { lat, lng } = map.containerPointToLatLng([size.x / 2, size.y / 2]);
  return { lat, lng };
}

export function scrollToMapIfMobile(mapElement: HTMLElement | null): void {
  if (typeof window === "undefined") return;
  if (window.innerWidth > BOOKING_PANEL_LAYOUT_BREAKPOINT_PX || !mapElement) return;
  mapElement.scrollIntoView({ behavior: "smooth", block: "start" });
}
